





































































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import SDropdown from '@/components/UI/SDropdown.vue';
import DocumentControls from '../../Shared/DocumentControls.vue';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import CreditNoteButton from '../CreditNoteButton.vue';
import InvoiceMailButton from './InvoiceMailButton.vue';
import { GET_CUSTOMER } from '@/queries/Customer';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_unitInvoiceSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting, GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting } from '@/queries/__generated__/unitInvoiceSetting';
import { GQL_customer_customer } from '@/queries/__generated__/customer';
import { GQL_InvoiceDeliveryMethodEnum } from '@/queries/global';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import ShowPdfButton from '../../Shared/Buttons/ShowPdfButton.vue';
import DuplicateInvoiceButton from './DuplicateInvoiceButton.vue';
import InvoiceDeliveryLogs from './InvoiceDeliveryLogs.vue';
import InvoiceDeliveryButton from './InvoiceDeliveryButton.vue';
import InvoiceSendByEHFButton from './InvoiceSendByEHFButton.vue';
import InvoiceSendByEfakturaButton from './InvoiceSendByEfakturaButton.vue';
import { sortBy } from '@/utils/utils';
import InvoicePaymentMethodForm from './../InvoicePaymentMethod/InvoicePaymentMethodForm.vue';
import InvoiceOverdueNoticesList from '../InvoiceOverdueNotices/InvoiceOverdueNoticesList.vue';
import gql from 'graphql-tag';
import { EFAKTURA_SETUP } from '@/queries/Efaktura';

const INVOICE_PDF = gql`
  query invoicePdf($id: ID!) {
    invoice(id: $id) {
      id
      pdf {
        id
        url
      }
    }
  }
`;


@Component({
  components: {
    DocumentControls,
    CreditNoteButton,
    InvoiceMailButton,
    DuplicateInvoiceButton,
    ShowPdfButton,
    InvoiceDeliveryLogs,
    InvoiceDeliveryButton,
    InvoiceSendByEHFButton,
    InvoiceSendByEfakturaButton,
    InvoicePaymentMethodForm,
    InvoiceOverdueNoticesList,
  },
})
export default class InvoiceShowControls extends Vue {
  @SmartQuery(EFAKTURA_SETUP) private efakturaSetup!: boolean;

  @SmartQuery<InvoiceShowControls, GQL_unitInvoiceSetting>({
    query: () => UNIT_INVOICE_SETTINGS,
    update: (data) => data.currentUnit.unitSetting,
  }) public unitSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting;

  @SmartQuery({
    query: () => GET_CUSTOMER,
    variables() {
      return {
        id: this.invoice.customer.id,
      };
    },
  }) public customer!: GQL_customer_customer;

  @SmartQuery<InvoiceShowControls, GQL_unitInvoiceSetting>({
    query: () => UNIT_INVOICE_SETTINGS,
    update: (data) => data.currentUnit.unitSetting.unitInvoiceSetting,
  }) private unitInvoiceSetting!: GQL_unitInvoiceSetting_currentUnit_unitSetting_unitInvoiceSetting;

  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;

  @Ref() private invoiceLogsDropdown!: SDropdown;

  private INVOICE_PDF = INVOICE_PDF;

  private get deliveryMethod() {
    const mostRecentLog = sortBy(this.invoice.emailLogs, log => [ [ log.sentAt.valueOf(), 'desc' ] ])[0];

    if (!mostRecentLog) return null;

    return mostRecentLog.deliveryMethod;
  }

  private get initialMailDestination() {
    return `${this.customer.unit.address}, ${this.customer.unit.zip}, ${this.customer.unit.city}`;
  }

  // "manual" isn't a real send method, so its label ("Don't send / uses
  // fakturaBank") reads badly inside the "prefers receiving by X" sentence —
  // use a dedicated sentence for it instead.
  private get deliveryPreferenceText() {
    const method = this.customer.invoiceDeliveryMethod;

    if (method === GQL_InvoiceDeliveryMethodEnum.manual) {
      return this.$t('Invoice.deliveryMethodPreferenceManual', {
        customer: this.customer.unit.name,
      });
    }

    return this.$t('Invoice.deliveryMethodPreference', {
      customer: this.customer.unit.name,
      method: this.$t(`Invoice.DeliveryLogs.DeliveryMethod.${method}`),
    });
  }
}
